var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.options),function(option,idx){return _c('Option',{key:option + idx,staticClass:"select",attrs:{"value":option.id || option.name || option,"label":_vm.$t(option.name || option)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }